import { create } from 'zustand'

import { PaymentSession, VisitorData } from './visitor-parking.types'

type VisitorParkingState = {
  visitor: VisitorData | null
  duration: number
  paymentSession: PaymentSession | null
  // Note: Store trackingSessionId for entire flow to associate all events for session
  trackingSessionId: string
  setVisitor: (visitor: VisitorData) => void
  setDuration: (duration: number) => void
  setPaymentSession: (paymentSession: PaymentSession) => void
  reset: () => void
}

const useVisitorParkingStore = create<VisitorParkingState>((set) => ({
  duration: 1,
  paymentSession: null,
  reset: () => set({ duration: 1, paymentSession: null, visitor: null }),
  setDuration: (duration: number) => set({ duration }),
  setPaymentSession: (paymentSession: PaymentSession) => set({ paymentSession }),
  setVisitor: (visitor: VisitorData) => set({ visitor }),
  trackingSessionId: new Date().getTime().toString(),
  visitor: null,
}))

export { useVisitorParkingStore }
